import { render, staticRenderFns } from "./cover-image.vue?vue&type=template&id=ca930248&"
import script from "./cover-image.vue?vue&type=script&lang=js&"
export * from "./cover-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VCard,VResponsive})
